<template>
  <div id="" class="">
    <dg-nav></dg-nav>
    <router-view />
    <dg-footer :linkData="linkData"></dg-footer>


  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      linkData: {},
    };
  },
  methods: {
    getLinkData() {
      ajax.post({
        url: "/website/platformService/platformService",
        data: {},
        self: this,
        success: (res) => {
          this.linkData = res || {};
        },
        fail: () => { },
      });
    },
  },
  mounted() {
    this.getLinkData()
    // console.log(this.$route.path)

  },
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  border: 0;
  font-size: 14px;
  box-sizing: border-box;
}

input {
  border: none;
  color: inherit;
  font: inherit;
  outline: 0
}

.el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
</style>
